import React, { Fragment } from "react";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";

import EnhancedTableHead from "components/Global/Table/EnhancedTableHead";
import BuildColumns from "components/Global/TablePreferenceColumns/BuildColumns";

class PrefTable extends React.Component {
  columns = [];
  static defaultProps = {
    shouldHideExport: false,
    shouldHideDealExport: true
  }

  render() {
    const {
      tableSettings,
      screenPreferences,
      screenType,
      tableLabel,
      handleRequestSort,
      handleChangePage,
      handleChangeRowsPerPage,
      TableScreenElements,
      getRows,
      pathFunction,
      tableClasses,
      shouldHideConfig,
      shouldHideExport,
      callbacks,
      dealId,
      exportTable,
      shouldHidePageControls,
      shouldHideDealExport
    } = this.props;

    let tableClassNames = tableClasses;
    if (!tableClassNames)
      tableClassNames = "loansList_Table tableBlueHover";

    if (!tableSettings.tableData) return null;
    if (!screenPreferences) return null;
    if (!tableSettings.dataMap) {
      console.error("missing tableSettings.dataMap for preferences table.");
    }
    if (!tableSettings.getCount)
      tableSettings.getCount = () => tableSettings.tableData.count;
    let filteredTableScreenElements = TableScreenElements
    if(this.props.shouldHideOptionsMenu){
      filteredTableScreenElements = filteredTableScreenElements.filter(x=>x.id!=="menu");
    }
    BuildColumns(screenPreferences, filteredTableScreenElements, this.columns);
    return (
      <Fragment>
        {tableLabel}
        {tableSettings.tableData && this.columns.length > 0 ? (
          <div style={{overflowX:"auto",margin:0,padding:0}}>
            <Table className={tableClassNames} id={this.props.screenType+"Table"} style={{overflowX:"scroll"}}>
              <EnhancedTableHead
                shouldHideConfig={shouldHideConfig}
                shouldHideExport={shouldHideExport}
                shouldHideDealExport={shouldHideDealExport}
                numSelected={tableSettings.selected.length}
                order={tableSettings.orderDir}
                orderBy={tableSettings.orderBy}
                onRequestSort={handleRequestSort}
                rowCount={tableSettings.count}
                columns={this.columns}
                metrics={screenPreferences}
                screenType={screenType}
                onClose={() => {
                  this.columns = [];
                }}
                dealId={dealId}
                exportTable={exportTable}
              />
              <TableBody>
                {getRows(
                  tableSettings.dataMap(tableSettings.tableData.data),
                  tableSettings.tableData.order,
                  this.columns,
                  callbacks,
                  pathFunction
                )}
              </TableBody>
              {!this.props.shouldHidePageControls &&
                <TableFooter>
                    <TableRow>
                      <TablePagination
                        count={tableSettings.getCount(tableSettings.tableData)}
                        rowsPerPage={tableSettings.rowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 100]}
                        page={tableSettings.page}
                        backIconButtonProps={{
                          "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                          "aria-label": "Next Page"
                        }}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        labelDisplayedRows={() => `${tableSettings.page + 1} of ${Math.ceil(tableSettings.getCount(tableSettings.tableData) / tableSettings.rowsPerPage)}`}
                      />
                    </TableRow>  
                </TableFooter>
            }
            </Table>
          </div>
        ) : (
          <div>Loading</div>
        )}
      </Fragment>
    );
  }
}

export default PrefTable;
